import uniqBy from 'lodash/uniqBy';

import { formatSocialProfileType } from '@/lib/socialProfile';

import {
    PeriodCell,
    FormatCell,
    ActionsCell,
    CreatedAtCell,
    FrequencyCell,
    RecipientCell,
    NextDeliveryCell,
    ContentCell,
    ActionsDownloadCell,
    TypeCell,
    TitleCell
} from '@/components/pages/reports/components/Cells';

export const ScheduledReportColumns = (t, toggle, setModalParams) => [
    {
        Header: t('reports:general.type_title'),
        id: 'type',
        accessor: 'type',
        Cell: TypeCell
    },
    {
        Header: t('reports:general.title_title'),
        id: 'name',
        accessor: 'name',
        sortable: 'name',
        Cell: TitleCell
    },
    {
        Header: t('reports:general.content_title'),
        id: 'content',
        accessor: (row) => {
            const sp = [];
            row?.social_profiles?.map((profile) => {
                sp.push({
                    value: profile?.slug,
                    label: `${profile?.slug} (${formatSocialProfileType(profile)})`,
                    id: profile?.id
                });
            });
            const outputFiltered = uniqBy(sp, 'id');
            return outputFiltered?.map((el) => el?.label)?.join(' ') ?? '';
        },
        Cell: (row) => ContentCell({ value: row?.cell?.row?.original }),
        disableSortBy: true
    },
    {
        Header: t('reports:general.format_title'),
        id: 'format',
        accessor: 'format',
        sortable: 'type',
        Cell: FormatCell
    },
    {
        Header: t('reports:general.frequency'),
        id: 'frequency',
        accessor: 'frequency',
        sortable: 'frequency',
        Cell: FrequencyCell
    },
    {
        Header: t('reports:general.delivery'),
        id: 'next_execution',
        accessor: 'next_execution',
        sortable: 'next_execution',
        Cell: NextDeliveryCell
    },
    {
        Header: t('reports:general.recipients'),
        id: 'recipients',
        accessor: 'params.emails',
        Cell: RecipientCell
    },
    {
        id: 'edit',
        accessor: '',
        Cell: (row) => ActionsCell({ toggle, setModalParams, row })
    }
];

export const HistoryReportColumns = (t) => [
    {
        Header: t('reports:general.type_title'),
        id: 'type',
        accessor: 'type',
        Cell: TypeCell
    },
    {
        Header: t('reports:general.title_title'),
        id: 'name',
        accessor: 'name',
        sortable: 'name',
        Cell: TitleCell
    },
    {
        Header: t('reports:general.content_title'),
        id: 'content',
        accessor: (data) => {
            const sp = [];
            data?.social_profiles?.map((profile) => {
                sp?.push({
                    value: profile?.slug,
                    label: `${profile?.slug} (${formatSocialProfileType(profile)})`,
                    id: profile?.id
                });
            });
            const outputFiltered = uniqBy(sp, 'id');
            return outputFiltered?.map((el) => el?.label)?.join(' ') ?? '';
        },
        Cell: (row) => ContentCell({ value: row?.cell?.row?.original })
    },
    {
        Header: t('reports:general.format_title'),
        id: 'format',
        accessor: 'format',
        sortable: 'params->type',
        Cell: FormatCell
    },
    {
        Header: t('reports:general.period_title'),
        id: 'period',
        accessor: 'start_date',
        sortable: 'params->period',
        Cell: PeriodCell
    },
    {
        Header: t('reports:general.creation_title'),
        id: 'created_at',
        accessor: 'created_at',
        sortable: 'created_at',
        Cell: CreatedAtCell
    },
    {
        Header: t('reports:general.recipients'),
        id: 'recipients',
        accessor: 'params.emails',
        Cell: RecipientCell
    },
    {
        id: 'download',
        accessor: '',
        Cell: ActionsDownloadCell
    },
    {
        id: 'frequency',
        accessor: 'frequency'
    }
];
